<template>
    <label
        class="block mb-2 text-sm font-bold text-gray-700"
        :for="name"
    >
        <slot />
        <span
            v-if="required"
            class="text-red-500"
        >
            *
        </span>
        <Tooltip v-if="tooltip">
            <template slot="title">
                <span>{{ tooltip }}</span>
            </template>
            <Icon
                type="question-circle"
                class="ml-1"
            />
        </Tooltip>

    </label>
</template>
<script>
import { Icon, Tooltip } from 'ant-design-vue';

export default {
    components: {
        Tooltip,
        Icon,
    },
    props: {
        name: {
            type: String,
            required: true,
        },
        tooltip: {
            type: String,
            default: null,
        },
        required: {
            type: Boolean,
            default: false,
        },
    },
};
</script>